import 'jquery';

window.jquery = $;

import { ajax } from '../components/ajax.js';
import { Breakpoints } from '../components/breakpoints.js';
import { Components } from '../components/components.js';
import { Cookie } from '../components/cookie.js';
import { Datepicker } from '../components/datepicker.js';
import { Environment } from '../components/environment.js';
import { Events } from '../components/events.js';
import { errorHandler } from '../components/errorhandler.js';
import { Foldout } from '../components/foldout.js';
import { GlobalMenu } from '../components/globalmenu.js';
import { Header } from '../components/header.js';
import { HorizontalScroll } from '../components/horizontalscroll.js';
import { init } from '../components/init.js';
import { Layout } from '../components/layout.js';
import { Lists } from '../components/lists.js';
import { Loader } from '../components/loader.js';
import { LanguageChooser } from '../components/languagechooser.js';
import { Login } from '../components/login.js';
import { Menu } from '../components/menu.js';
import { Modal } from '../components/modal.js';
import { Modals } from '../components/modals.js';
import { Search } from '../components/Search.js';
import { SessionMonitor } from '../components/sessionmonitor.js';
import { Sidebar } from '../components/sidebar.js';
import { Spinner } from '../components/spinner.js';
import { SystemMenu } from '../components/systemmenu.js';
import { Tab } from '../components/tab.js';
import { Ticker } from '../components/ticker.js';
import { Tooltip } from '../components/tooltip.js';
import { Translations } from '../components/translations.js';
import { User } from '../components/user.js';
import { UserMenuModal } from '../components/usermenumodal.js';
import * as utils from '../components/utils.js';

export class UnifyCore {
    constructor() {

    }

    initialize(o) {
        o = typeof o !== 'undefined' ? o : {};
        var globalTranslations = typeof o.translations !== 'undefined' ? o.translations : '';
        var isATestEnvironment = typeof o.isATestEnvironment !== 'undefined' ? o.isATestEnvironment : true;
        var endpoints = typeof o.endpoints !== 'undefined' ? o.endpoints : '';
        var exports = typeof o.exports !== 'undefined' ? o.exports : undefined;

        if (globalTranslations === '') {
            console.log('Error UnifyCore, need to be initialized with translations, o:', o);
            return;
        }

        if (endpoints === '') {
            console.log('Error UnifyCore, need to be initialized with endpoints, o:', o);
            return;
        }

        var unify = exports || {};

        var translations = new Translations(globalTranslations);
        var t = translations.get();
        unify.phrases = {};
        unify.phrases.translations = {};
        unify.phrases.translations.common = t.common;
        unify.phrases.translations.internal = t.internal;

        unify.ajax = ajax;
        unify.breakpoints = new Breakpoints();
        unify.components = new Components();

        unify.contact = new UserMenuModal({
            translations: {
                closeText: t.common.Close,
                message: t.internal.ContactInfo,
                title: t.internal.ContactInfoLinkText
            }
        });

        unify.cookie = new Cookie();
        unify.cookiePolicy = new UserMenuModal({
            translations: {
                closeText: t.common.Close,
                message: t.internal.CookiePolicy,
                title: t.internal.CookiePolicyLinkText
            }
        });

        unify.dataProcessingDeclaration = new UserMenuModal({
            translations: {
                closeText: t.common.Close,
                message: t.internal.DataProcessingDeclaration,
                title: t.internal.DataProcessingDeclarationLinkText
            }
        });
        unify.datepicker = new Datepicker();

        var environment = new Environment({
            translations: t, // t.common.Close is used in header... when setSystemInformation is called a header object is created
            isATestEnvironment: isATestEnvironment
        });

        unify.environment = environment;
        unify.setSystemInformation = function (o) {
            unify.environment.setSystemInformation(o);
        };

        unify.events = new Events();
        unify.Foldout = Foldout;
        unify.foldout = new Foldout();
        unify.logError = errorHandler;

        unify.globalMenu = new GlobalMenu();
        unify.setGlobalMenu = function (json) {
            unify.globalMenu.setGlobalMenu(json);
            /*
            * Add the scrolling menu to header, in menu Uri is used instead of Url
            */
            // deep copy
            var nonHamburgerMenuItems = $.grep(json,
                function (mi) {
                    return typeof mi.DisplayLocation === "undefined" || mi.DisplayLocation !== 'Hamburger';
                });

            var copiedObject = jQuery.extend(true, [], nonHamburgerMenuItems);
            var jsonRenamed = utils.renameProperties({
                objects: copiedObject,
                propertyChangeArray: [{ oldName: 'Url', newName: 'Uri' }]
            });
            unify.headerMenu = new Menu('.unify-header-flex-center', jsonRenamed);
            unify.headerMenu.init();
        };

        unify.Header = Header;
        unify.appendCookieContactLegalToHeader = function () {
            var header = new Header({
                translations: t
            });
            header.appendContactToHeader(unify.contact);
        };

        unify.horizontalScroll = new HorizontalScroll();
        // Kept for backwards compatability
        unify.injectHorizontalScroll = function (selector, options, ftscrollerOptions) {
            return unify.horizontalScroll.inject(selector, options, ftscrollerOptions);
        };
        unify.components.injectHorizontalScroll = unify.injectHorizontalScroll;

        var languageChooser = new LanguageChooser();
        languageChooser.onLocalizationChangedIsSet = function () { return typeof window.unify.onLocalizationChange !== 'undefined'; };
        languageChooser.onLocalizationChanged = function () { return window.unify.onLocalizationChange(); };
        unify.localizations = languageChooser;
        unify.setLocalizations = function (json) { unify.localizations.setLocalizations(json); };
        Object.defineProperty(unify, "currentCulture", {
            get: function () {
                return unify.localizations.currentCulture;
            }
        });

        unify.layout = new Layout();
        unify.addUpdateToComponentsOnPageReady = function () { unify.layout.addUpdateToComponentsOnPageReady(); };
        unify.addUpdateToComponentsOnTabClick = function () { unify.layout.addUpdateToComponentsOnTabClick(); };
        unify.recalcAllDataTablesWithPluginResponsiveThatIsVisible = function () {
            unify.layout.recalcAllDataTablesWithPluginResponsiveThatIsVisible();
        };
        unify.recalcAllHighchartsThatIsVisible = function () { unify.layout.recalcAllHighchartsThatIsVisible(); };

        unify.lists = new Lists();
        unify.loader = new Loader();

        unify.login = new Login({
            translations: t,
            endpoints: endpoints
        });

        unify.Modal = Modal;
        Modal.addBackdropZIndexFix();
        Modal.addScrollbarFix();

        unify.modals = new Modals();
        unify.search = new Search();
        var sessionMonitor = new SessionMonitor();
        sessionMonitor.initialize({
            translations: t,
            endpoints: endpoints
        });
        unify.sessionMonitor = sessionMonitor;
        unify.sidebar = new Sidebar();
        unify.spinner = new Spinner();
        unify.systemMenu = new SystemMenu();
        unify.Tab = Tab;

        unify.termsOfService = new UserMenuModal({
            translations: {
                closeText: t.common.Close,
                message: t.internal.TermsOfService,
                title: t.internal.TermsOfServiceLink
            }
        });

        unify.ticker = new Ticker();
        unify.tooltip = new Tooltip($);

        unify.currentUser = new User({
            translations: t,
            endpoints: endpoints
        });
        unify.elevate = function (o) { unify.currentUser.elevate(o); };
        unify.initiateImpersonation = function (o) { unify.currentUser.initiateImpersonation(o); };
        unify.monitorNotification = function (o) { unify.currentUser.monitorNotification(o); };
        unify.monitorSession = function () {
            if (unify.currentUser.isAuthenticated) {
                unify.sessionMonitor.start();
            }
        };
        unify.renewSessionCookie = function (o) { unify.sessionMonitor.updateSessionCookie(o); };
        unify.setUserInformation = function (o) { unify.currentUser.setUserInformation(o); };
        unify.showChangePassword = function (o) { unify.currentUser.showChangePassword(o); };
        unify.showImpersonateUser = function (o) { unify.currentUser.showImpersonateUser(o); };
        unify.signout = function (reason, forceLeave) { unify.currentUser.signout(reason, forceLeave); };
        unify.updateImpersonateUserButtonDisabled = function (o) {
            unify.currentUser.updateImpersonateUserButtonDisabled(o);
        };
        unify.updateImpersonateUserSelect = function (o) { unify.currentUser.updateImpersonateUserSelect(o); };

        unify.utils = utils;
        unify.closePopoverIfClickingOnBody = utils.closePopoverIfClickingOnBody;
        unify.getClosestTransformedElement = function (element) {
            return unify.utils.getClosestTransformedElement(element);
        };
        unify.getRandomInt = function (min, max) { return unify.utils.getRandomInt(min, max); };
        unify.inlineExternalSVGs = utils.inlineExternalSVGs;
        unify.onFTScrollerScrollabilityChange = function (a, b) { unify.utils.onFTScrollerScrollabilityChange(a, b); };
        unify.showNotification = function (o) { unify.utils.showNotification(o); };
        unify.stopBubbling = function (event) { unify.utils.stopBubbling(event); };

        // ugly fix, SignOut.cshtml needs global endpoints
        unify.endpoints = endpoints;
    }
}